import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import MuiCard from '@material-ui/core/Card';

import styles from './card.styles';

const Card = ({ classes, children, type, scrollable, ...props }) => {
  return (
    <MuiCard
      className={scrollable ? classes.scrollable : ''}
      classes={{
        root: classes[type]
      }}
      {...props}
    >
      {children}
    </MuiCard>
  );
};

Card.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  scrollable: PropTypes.bool,
  type: PropTypes.oneOf([
    'primary',
    'primaryEditable',
    'secondary',
    'tertiary',
    'quatrinary',
    'highlight',
    'outline',
    'noBorders',
    'noBordersTop',
    'scrollable',
    'noData'
  ])
};

Card.defaultProps = {
  type: 'primary',
  scrollable: false
};

export default withStyles(styles)(Card);
